import { createSlice, current } from "@reduxjs/toolkit";


const initialState = {
    data: {
        facilitiesdata: [],
        facilityid: null,
        facilitiesdatapoint: {
            ghg: [],
            waste: [],
            water: [],
            energy: [],
            air: []
        }
    },
    loading: false,
    error: null,
};

const facilitiesSlice = createSlice({
    name: 'facilities',
    initialState,
    reducers: {

        // Loading .... 

        start(state) {
            state.loading = true;
            state.error = null;
        },
        failure(state, action) {
            state.loading = false;
            state.error = action.payload;
        },

        // facilities store ...... 

        getFacilitiesSuccess(state, action) {
            state.loading = false;
            state.data.facilitiesdata = action.payload;
        },


        getFacilitiesDataPointGhg(state, action) {
            state.loading = false;
            state.data.facilitiesdatapoint.ghg = action.payload;
        },
        getFacilitiesDataPointAir(state, action) {
            state.loading = false;
            state.data.facilitiesdatapoint.air = action.payload;
        },
        getFacilitiesDataPointWater(state, action) {
            state.loading = false;
            state.data.facilitiesdatapoint.water = action.payload;
        },
        getFacilitiesDataPointEnergy(state, action) {
            state.loading = false;
            state.data.facilitiesdatapoint.energy = action.payload;
        },
        getFacilitiesDataPointWaste(state, action) {
            state.loading = false;
            state.data.facilitiesdatapoint.waste = action.payload;
        },

        addFacilities(state, action) {
            state.loading = false;
            state.data.facilitiesdata = action.payload;
        },

        saveFacilityId(state, action) {
            state.loading = false;
            state.data.facilityid = action.payload;
        },

         deleteFacilities(state, action) {
            state.loading = false;
            const idToDelete = action.payload;
            state.data.facilitiesdata = state.data.facilitiesdata.filter(
                (facility) => facility.id !== idToDelete
            );
        },

    },
});

export default facilitiesSlice.reducer;
export const {
    start,
    failure,
    getFacilitiesSuccess,
    addFacilities,
    getFacilitiesDataPointGhg,
    getFacilitiesDataPointAir,
    getFacilitiesDataPointWater,
    getFacilitiesDataPointEnergy,
    getFacilitiesDataPointWaste,
    deleteFacilities,
    saveFacilityId } = facilitiesSlice.actions;